import { render, staticRenderFns } from "./LayoutAdmin.vue?vue&type=template&id=04099cd4&scoped=true"
import script from "./LayoutAdmin.vue?vue&type=script&lang=js"
export * from "./LayoutAdmin.vue?vue&type=script&lang=js"
import style0 from "./LayoutAdmin.vue?vue&type=style&index=0&id=04099cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04099cd4",
  null
  
)

export default component.exports